import BulkQuoteUpload from "./BulkQuoteUpload";
export default BulkQuoteUpload;
